/**
 * Pattern keys for integrity disposition memory (code + house, not volatile counts).
 */
export function integrityPatternKey(code: string, houseId?: string | null): string {
  const safeCode = String(code ?? '').trim() || 'unknown';
  const house = String(houseId ?? '').trim() || 'global';
  return `${safeCode}__${house}`.replace(/\//g, '_');
}

/** suppressed / false-positive: do not re-alert this pattern. */
export function shouldPersistIntegritySuppression(disposition: string): boolean {
  return disposition === 'suppressed' || disposition === 'fp';
}

/** open / true-positive: clear pattern suppression so alerts can return. */
export function shouldClearIntegritySuppression(disposition: string): boolean {
  return disposition === 'open' || disposition === 'tp';
}
